<div class="container">
  <mat-card>
    <ng-content select="div.first"></ng-content>
  </mat-card>
  <mat-card>
    <ng-content select="div.second"></ng-content>
  </mat-card>
</div>
